import React from 'react';
import { MapperPaginationSize } from '../../constants/constants';
import { deepClone } from '../../utilities';
import { MappingEntry } from './mapping_entry';
import { ColumnLayout, Button, Alert } from 'AWS-UI-Components-React';
import { Pagination } from './pagination';

export class MappingGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title || 'Mapping Group',
      mappingEntries: props.mappingEntries || [],
      types: props.types || [],
      columnsMap: props.columnsMap || {},
      filterMappingEntries: [],
      displayMappingEntries: [],
      initialSetup: true,
      currentPage: 0,
      filterText: "",
      componentMappings: props.componentMappings || {},
      subComponentDropdownValues: {},
      subComponentMappings: props.subComponentMappings,
      subComponentEdit: props.subComponentEdit,
      removeMessageVisible: true,
      removeInProgress: false,
      removeId: 0,
      editId: 0,
    };

    this.state.requiredColumnCount = 4;
    this.state.showType = true;
    if (this.state.types && this.state.types.length < 2 && !props.datasetNeeded) {
      this.state.requiredColumnCount = 3;
      this.state.showType = false;
    }

    this.state.originalMappingEntries = Object.assign({}, this.state.mappingEntries);
    this.state.originalSubComponentMappings = deepClone(this.state.subComponentMappings);

    let counter = 0;
    for (let mappingEntry of this.state.mappingEntries) {
      mappingEntry['index'] = counter;
    }

    this.onRemove = this.onRemove.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onEdit = this.onEdit.bind(this);
  }

  componentWillMount = () => {
    if (this.state.initialSetup) {
      this.state.filterMappingEntries = deepClone(this.state.mappingEntries);
      this.state.displayMappingEntries = this.state.filterMappingEntries.slice(0, MapperPaginationSize);
      this.setState({initialSetup: false});
    }
    this.state.subComponentEdit && this.setSubComponentDropdownValues();
  };

  setSubComponentDropdownValues = () => {
    this.state.componentMappings[0] &&
    this.setState({ subComponentDropdownValues: this.state.componentMappings[0].cognosBenchmark.concat(this.state.componentMappings[0].accuracyBenchmark) });
  };


  getSubComponentName = (id) => {
    if (this.state.originalSubComponentMappings) {
      for (let subComponent of this.state.originalSubComponentMappings) {
        let combinedBenchmarkValues = subComponent.cognosBenchmark.concat(subComponent.accuracyBenchmark);
        if (combinedBenchmarkValues.map(v => v.value).includes(id)) {
          return subComponent.subComponent;
        }
      }
    }
    return "No mapping found";
  };

  disableRemoveMessage = () => {
    this.setState({ removeMessageVisible: false, removeInProgress: false, editInProgress: false });
  };

  displayRemoveMessage = (id) => {
    let subComponent = this.getSubComponentName(id);
    return (
      !subComponent.includes("No mapping found") && (
      <div className="awsui-util-t-c">
        <div className="awsui-util-pt-xs">
          <div className="awsui-util-pt-xs awsui-util-mb-xs">
            <Alert
              onDismiss={this.disableRemoveMessage}
              visible={this.state.removeMessageVisible}
              dismissAriaLabel="Close alert"
              dismissible>
              <div> Account <b>{id}</b> will be removed from SubComponent <b>{subComponent}</b> as it is being removed from parent
                    component <b>{ this.state.componentMappings[0].component }</b> </div>
            </Alert>
          </div>
        </div>
      </div>
    ))
  };

  removeSubComponentEntries = (removeId, mappings) => {
    for(let subComponent of mappings) {
      if (this.state.title.includes("P&L")) {
        subComponent.cognosBenchmark.map(v => v.value).includes(removeId) ?
        subComponent.cognosBenchmark.splice(this.fetchIndexById(subComponent.cognosBenchmark, removeId), 1) : "";
      } else if(this.state.title.includes("Accuracy")) {
        subComponent.accuracyBenchmark.map(v => v.value).includes(removeId) ?
        subComponent.accuracyBenchmark.splice(this.fetchIndexById(subComponent.accuracyBenchmark, removeId), 1) : "";
      }
    }
  };

  onRemove = (id) => {
    this.state.mappingEntries.splice(this.fetchIndexById(this.state.mappingEntries, id), 1);
    this.state.filterMappingEntries.splice(this.fetchIndexById(this.state.filterMappingEntries, id), 1);
    !this.state.subComponentEdit && this.state.subComponentMappings && this.removeSubComponentEntries(id, this.state.subComponentMappings);
    this.setState({
                    mappingEntries: this.state.mappingEntries,
                    subComponentMappings: this.state.subComponentMappings,
                    removeInProgress: true, removeId: id,
                    filterMappingEntries: this.state.filterMappingEntries
                  }, () => {
      this.props.validate();
      this.handlePageClick({selected: this.state.currentPage});
    });
  };

  fetchIndexById = (entries, id) => {
    return entries.findIndex(entry => entry.value === id);
  };

  onAdd = () => {
    let type = '';
    if (this.state.types.length === 1) {
      type = this.state.types[0].id;
    } else {
      type = 'Cognos';
    }
    let mappingEntries = this.state.mappingEntries;
    mappingEntries.push({
      index: this.state.mappingEntries.length + 1,
      operation: '+',
      type: type,
      value: '',
    });
    this.state.subComponentEdit && this.setSubComponentDropdownValues();
    this.props.validate();
    this.setState({ mappingEntries: mappingEntries, filterMappingEntries: deepClone(mappingEntries), filterText: ""}, () => {
      const lastPage = Math.floor(this.state.filterMappingEntries.length / MapperPaginationSize);
      this.handlePageClick({selected: lastPage});
    });
  };

  onEdit = (id, mappingEntry) => {
    let mappingEntries = this.state.mappingEntries;
    mappingEntries[this.fetchIndexById(this.state.mappingEntries, id)] = mappingEntry;
    let filterMappingEntries = this.state.filterMappingEntries;
    filterMappingEntries[this.fetchIndexById(this.state.filterMappingEntries, id)] = mappingEntry;
    !this.state.subComponentEdit && this.state.subComponentMappings && this.removeSubComponentEntries(id, this.state.subComponentMappings);
    this.props.validate();
    this.setState({ mappingEntries: mappingEntries, filterMappingEntries: filterMappingEntries, editInProgress: true, editId: id }, () => {
      this.handlePageClick({selected: this.state.currentPage});
    });
  };

  handlePageClick = (data) => {
    let offset = Math.ceil(data.selected * MapperPaginationSize);

    let currentDisplayLists = this.state.filterMappingEntries.slice(offset, offset + MapperPaginationSize);
    this.setState({displayMappingEntries: currentDisplayLists, currentPage: data.selected});
  };

  filterList = (event) => {
    let updatedList = deepClone(this.state.mappingEntries);

    let columnsMap = this.state.columnsMap;

    updatedList = updatedList.filter(function(list) {
      let account = columnsMap[list.type].find(x => x.id === list.value);
      if (!account) return false;
      let key = account.label;
      return (
        key.toLowerCase().search(event.target.value.toLowerCase()) !== -1
      );
    });

    this.setState({filterMappingEntries: updatedList, filterText: event.target.value}, () => {
      this.handlePageClick({selected: 0});
    });
  };

  render() {
    const pageCount = Math.ceil(this.state.filterMappingEntries.length / MapperPaginationSize);
    const originalCount = Math.ceil(this.state.mappingEntries.length / MapperPaginationSize);

    return (
      <div className="awsui-util-container">
        <div className="awsui-util-container-header">
          <h3>
            {this.state.title}
            <div> { this.state.removeInProgress && !this.state.subComponentEdit && this.displayRemoveMessage(this.state.removeId) } </div>
            <div> { this.state.editInProgress && !this.state.subComponentEdit && this.displayRemoveMessage(this.state.editId) } </div>
            <div className="align-right">
              {pageCount > 1 && <Pagination
                pageCount={pageCount}
                onPageChange={this.handlePageClick}
              />}
              {originalCount > 1 && <input type="text" placeholder="Filter" onChange={this.filterList} value={this.state.filterText}/>}
            </div>
          </h3>
        </div>
        <div>
          <ColumnLayout columns={1} className={'awsui-util-no-gutters'}>
            <div data-awsui-column-layout-root="true">
              <table>
                <tbody>
                {this.state.displayMappingEntries.map((item, index) => {
                  this.editorKey = 1 + this.editorKey || new Date().getTime();
                  return (
                    <MappingEntry
                      index={index}
                      key={this.editorKey}
                      types={this.state.types}
                      cpValueTypes={this.props.cpValueTypesOptions}
                      showType={this.state.showType}
                      columnsMap={this.state.columnsMap}
                      subComponentDropdownValues={this.state.subComponentDropdownValues}
                      operation={this.state.displayMappingEntries[index].operation}
                      type={this.state.displayMappingEntries[index].type}
                      value={this.state.displayMappingEntries[index].value}
                      editCallback={this.onEdit}
                      removeCallback={this.onRemove}
                    />
                  );
                })}
                </tbody>
              </table>
              <div className={'mapping-group-add-button'}>
                <Button text={'Add'} onClick={this.onAdd} />
              </div>
            </div>
          </ColumnLayout>
        </div>
      </div>
    );
  }
}

export default MappingGroup;



// WEBPACK FOOTER //
// ./src/components/mapper/mapping_group.jsx